import React, { useState, useEffect } from "react";
import "./reportgeneration.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { ReportGenerationAction, ReportNameListAction } from "../../actions/ReportGenerationAction";
import { useDispatch } from "react-redux";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { DowloadReportAction } from "../../actions/exceldownloadAction";
import { notify } from '../../services/notification';
import { HiMenu, HiX } from "react-icons/hi";
import {
  stateListAction,
  districtListAction
} from "../../actions/notificationAction";
import moment from "moment";
import Cookies from "js-cookie";
import { decode } from "base-64";
import { constant } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";
import DbtInvoiceScanStatus from "../DbtInvoiceScanStatus";


function ReportGeneration() {
  const Role = decode(Cookies.get('role'));
  const [isLoading, setLoading] = useState(false)
  const {  isSidebarOpen, toggleSidebar } = useMobileView();

  const [report, setReport] = useState(null);
  const [stateList, setStateList] = useState([]);
  const [district, setDistrict] = useState([]);
 
  const [reportNames, setReportNames] = useState([]);
  const userRegistrationReportId=reportNames?.find((item) => item?.slug==="user_registration")?.id;
  const [selectedReport, setSelectedReport] = useState("");
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const [states, setStates] = useState({
    districtid: "",
    selectedReportName: "",
    stateId: "",
    pgmId: "",
    agency_code: "",
    from_date: "",
    to_date: "",
    user_type: ""
  });
  useEffect(() => {
    if (states.selectedReportName && reportNames?.length > 0) {
      let arr = reportNames.filter((val) => val.id === Number(states.selectedReportName)) || [];
      if (arr?.length == 0) {
        return;
      }
      setSelectedReport(arr[0].slug)
      setReport(null)
    } else {
      setSelectedReport("")
      setReport(null)
    }
  }, [states.selectedReportName, reportNames])
  useEffect(() => {
    if (states?.districtid && reportNames?.length > 0) {
      setReport(null)
    }
    if (states?.user_type && reportNames?.length > 0) {
      setReport(null)
    }
  }, [states?.districtid, states?.user_type])
  

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    if (name === "selectedReportName") {
      setStates((prevStates) => ({
        ...prevStates,
        districtid: "",
        stateId: "",
        pgmId: "",
        agency_code: "",
        from_date: "",
        to_date: "",
        user_type: ""
      }));
    }
    let newValue = value.replace(/^ +/gm, "");

    setStates((prevStates) => ({
      ...prevStates,
      [name]: value.replace(/^ +/gm, ""),
    }));
  };

  const dispatch = useDispatch();
  async function GetRepotNameListData() {
    setLoading(true);
    var response = await dispatch(ReportNameListAction());
    if (response?.status === 200) {
      setLoading(false);
      setReportNames(response?.data?.data);
    }
  }
  
  const handleGenerate = () => {
    setPage(1)
    getReport(1)
  }

  async function getReport(pageNumber) {
    setLoading(true);
    var response = await dispatch(ReportGenerationAction(states?.selectedReportName, states?.stateId, selectedReport !== "user_registration" ? states?.pgmId : "", states?.districtid, pageNumber, states.from_date, states.to_date, states.agency_code, states?.user_type));
    if (response?.status === 200) {
      if (
        (response.data?.results?.length === 0 || 
         response.data?.results === 0 ||
         response.data?.results?.data?.length === 0
        )
      ) {
        notify.error("Report does not exist for the selected criteria");
      }
      setReport(response.data?.results?.length > 0 ? response.data?.results : 
        (response.data?.results?.data?.length > 0 ? response.data?.results?.data : []))
      setLoading(false);
      setCount(Math.ceil(response.data.count / constant.paginationCount))
      setpaginationListcount(response.data.count);
    } else if (response === undefined) {
      setLoading(false);
    }
  }

  useEffect(() => {
    StateListData()
    GetRepotNameListData()
  }, []);

  async function StateListData(state_id) {
    setLoading(true);
    var response = await dispatch(stateListAction(state_id));
    if (response.status === 200) {
      setLoading(false);
      setStateList(response.data?.results?.data);
    }
  }

  useEffect(() => {
    if (states.stateId !== ""){
      setReport(null);
      DistrictListData(states.stateId);
    }else{
      setDistrict([])
    }
  }, [states.stateId])

  // Function calling for District List based On state

  async function DistrictListData(state_id) {
    setLoading(true);
    var response = await dispatch(districtListAction(state_id));
    if (response.status === 200) {
      setLoading(false);
      setDistrict(response.data.data);
    }
  }

  async function DowloadReport() {
    try {
      const response = await dispatch(DowloadReportAction(states?.selectedReportName, states?.stateId, selectedReport !== "user_registration" ? states?.pgmId : "", states?.districtid, states.from_date, states.to_date, states.agency_code,states.user_type));

      if (response) {
              const messageText = await response.text();
              const jsonText = JSON.parse(messageText);
              notify.success(jsonText.message || 'Success');
           }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }

  const handlePageChange = (event, value) => {
    setPage(value);
    getReport(value)
  };

  const resetInputs = () => {
    setStates(prevStates => ({
      ...prevStates,
      districtid: "",
      from_date: "",
      to_date: "",
      stateId: "",
      agency_code: "",
      pgmId: ""
    }));
  };

  const [paginationListcount, setpaginationListcount] = useState(0);
  const startItem = report?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  return (
    <div className="report-container">
      <div className="report-right-sidebar">
        <Header title="Report" />
        {isLoading ? (
          <Loader />
        ) : (
          <div className="report-first-collumn">
            <div className="report-genration-mobile">
            <div className="report-main">
              <div className="report-left">
                <div className="report-input-label">
                  <label className="label-report-genration flex">Report Name<p className="star-mandatory">*</p></label>
                  <select name="selectedReportName" className="text-filed-dropdown" value={states.selectedReportName} onChange={handleChange}>
                    <option value="">Select Report Name</option>
                    {reportNames?.length > 0 && reportNames?.map((data) => (
                      <option key={data.id} value={data?.id}>
                        {data?.report_name}
                      </option>
                    ))}
                  </select>

                </div>
              </div>
              {selectedReport !== "scan_vs_invoice" && (
                <div className="report-right">
                  <div className="report-input-label-button">
                    <button className="download-excel" onClick={DowloadReport} disabled={!report || report?.length === 0 || !states.selectedReportName}>
                      <img src={Image_Url.EXCEL_LOGO} className="downloads-img-excel" />
                      Download Report
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Render DbtInvoiceScanStatus for scan_vs_invoice report */}
            {selectedReport === "scan_vs_invoice" && states.selectedReportName ? (
              <DbtInvoiceScanStatus reportId={states.selectedReportName} />
            ) : null}

            {
              states.selectedReportName && selectedReport !== "scan_vs_invoice" ?
                <div className="report-main" key={selectedReport}>
                  <div className="report-left">

                    <div className="report-input-label">
                      <label className="label-report-genration">From Date <p className="star-mandatory">*</p></label>
                      <input
                        type="date"
                        className="report-input"
                        placeholder="dd/mm/yyyy"
                        name="from_date"
                        value={states.from_date}
                        onChange={handleChange}
                        disabled={!states.selectedReportName}
                        max={moment().format("YYYY-MM-DD")} // Set max attribute to current date
                      />
                    </div>

                    <div className="report-input-label">
                      <label className="label-report-genration">State</label>
                      <select className="text-filed-dropdown" name="stateId" value={states.stateId} onChange={handleChange} disabled={!states.selectedReportName}>
                        <option value="">Select State</option>
                        {stateList?.map((item) => (
                          <option value={item.id}>{item.state}</option>
                        ))}
                      </select>
                    </div>
                    {
                      selectedReport !== "qr_code_failure_transaction" && selectedReport !== "qr_code_scan_summary" ?
                        <div className="report-input-label">
                          <label className="label-report-genration">MSR Id</label>
                          <input type="text" className="text-filed-dropdown" name="agency_code" placeholder="MSR Id" value={states.agency_code} onChange={handleChange} disabled={!states.selectedReportName} />
                        </div>
                        :
                        <div className="report-input-label">
                          <label className="label-report-genration">PGM Id</label>
                          <input type="text" className="text-filed-dropdown" placeholder="PGM Id" name="pgmId" value={states?.pgmId} onChange={handleChange} disabled={!states.selectedReportName} />
                        </div>
                    }
                  </div>

                  <div className="report-right">
                    <div className="report-input-label">
                      <label className="label-report-genration">To Date <p className="star-mandatory">*</p></label>
                      <input
                        type="date"
                        className="report-input"
                        placeholder="dd/mm/yyyy"
                        name="to_date"
                        min={states.from_date} // Set min attribute to from_date to ensure to_date is not before from_date
                        max={moment().format("YYYY-MM-DD")}
                        value={states.to_date}
                        onChange={handleChange}
                        disabled={!states.selectedReportName || !states.from_date}
                      />
                    </div>
                    <div className="report-input-label">
                      <label className="label-report-genration">District</label>
                      <select value={states?.districtid} name="districtid" onChange={handleChange} className="text-filed-dropdown" disabled={!states.selectedReportName}>
                        <option value="">Select City/District</option>
                        {district?.map((list) => (
                          <option key={list.id} value={list.id}>
                            {list?.district}
                          </option>
                        ))}
                      </select>
                    </div>
                    { (selectedReport === "user_registration" || selectedReport === "qr_code_scan_summary") &&
                      <div className="report-input-label">
                        <label className="label-report-genration">User Type</label>
                        <select value={states?.user_type} name="user_type" onChange={handleChange} className="text-filed-dropdown" disabled={!states.selectedReportName}>
                          <option value="">Select User Type</option>
                          <option value={'pgm'}>PGM</option>
                          <option value={'retailer'}>Retailer</option>
                        </select>
                      </div>
                    }
                    <div className="report-input-label-button">
                      <button
                        type="button"
                        className="report-generate-button"
                        onClick={resetInputs}
                      >
                        Clear
                      </button>
                      <button
                        type="button"
                        className="report-generate-button"
                        onClick={handleGenerate}
                        disabled={!states.selectedReportName || !states.from_date || !states.to_date}
                      >
                        Generate
                      </button>
                    </div>
                  </div>
                </div>
                : ""
            }

            {report?.length > 0 && selectedReport !== "scan_vs_invoice" ?
              <div className="table-data">
                <div>
                  <table className="table">
                    <tr className="tablesth">
                      <th>User Id</th>
                      <th>User Name</th>
                      <th>User Type</th>
                      <th>Mobile No.</th>
                      <th>State</th>
                      <th>District</th>
                      <th>Pincode</th>
                      {(selectedReport === "user_registration" || selectedReport === "qr_code_scan_summary") && <th>APS Code</th>}
                      {(selectedReport === "user_registration" || selectedReport === "qr_code_scan_summary") && <th>APS Name</th>}
                      {(selectedReport === "user_registration" || selectedReport === "qr_code_scan_summary") && <th>Shop Name</th>}
                      {(selectedReport === "user_registration" || selectedReport === "qr_code_scan_summary") && <th>Zone Name</th>}
                      {selectedReport === "user_registration" && <th>Created On</th>}
                      {selectedReport === "user_registration" && <th>Registered On</th>}
                      {selectedReport === "user_registration" && <th>MSR Id</th>}
                      {selectedReport === "user_registration" && <th>Delete Status</th>}
                      {/* {selectedReport === "user_registration" && states?.user_type === 'retailer' && <th>POMS Linking Status</th>} */}
                      {selectedReport === "user_registration" && <th>POMS CC Linking Status</th>}
                      {selectedReport === "user_registration" && <th>POMS CC Linking Date</th>}
                      {selectedReport === "qr_code_failure_transaction" && <th>QR Code / Invoice No.</th>}
                      {selectedReport === "qr_code_failure_transaction" && <th>Invoice Status</th>}
                      {selectedReport === "qr_code_failure_transaction" && <th>Scan Date</th>}
                      {selectedReport === "qr_code_failure_transaction" && <th>Delete Status</th>}
                      {selectedReport === "qr_code_scan_summary" && <th >Total no. of scans</th>}
                      {selectedReport === "qr_code_scan_summary" && <th >Total points earned</th>}
                      {selectedReport === "qr_code_scan_summary" && <th >Total points redeemed</th>}
                      {selectedReport === "qr_code_scan_summary" &&
                        report?.length > 0 && report[0].monthly_details && Object.keys(report[0]?.monthly_details)?.map((val) =>
                          <>
                            <th >{val} total no. of scans</th>
                            <th >{val} total points earned</th>
                            <th >{val}  points redeemed</th>
                          </>

                        )
                      }
                   {selectedReport === "qr_code_scan_summary" && <th>Delete Status</th>}
                    </tr>
                    {
                      report?.length > 0 && report.map((item) =>
                        <tr className="tabletd">
                          <td>{item?.user_id || item.pgm_id || item.id}</td>
                          <td className="user-type-td">{item?.user_name || item?.name}</td>
                          <td className="user-type-td">{item?.user_type}</td>
                          <td>{item?.mobile_number}</td>
                          <td>{item?.state}</td>
                          <td>{item?.district}</td>
                          <td>{item?.pincode}</td>
                          {(selectedReport === "user_registration" || selectedReport === "qr_code_scan_summary") && <td>{item?.aps_code || '-'}</td>}
                          {(selectedReport === "user_registration" || selectedReport === "qr_code_scan_summary") && <td>{item?.aps_name || '-'}</td>}
                          {(selectedReport === "user_registration" || selectedReport === "qr_code_scan_summary") && <td>{item?.garage_name || '-'}</td>}
                          {(selectedReport === "user_registration" || selectedReport === "qr_code_scan_summary") && <td>{item?.zone_name || '-'}</td>}
                          {selectedReport === "user_registration" && <td>{moment(item?.created_at).format("DD-MM-YY")}</td>}
                          {selectedReport === "user_registration" && <td>{item?.registered_on}</td>}
                          {selectedReport === "user_registration" && <td>{item?.msr_id}</td>}
                          {selectedReport === "user_registration" && <td>{item.is_deleted === true ? "Yes":"No"}</td>}
                          {/* {selectedReport === "user_registration" && states?.user_type === 'retailer' && <td>{item?.is_retailer_linked}</td>} */}
                          {selectedReport === "user_registration" && <td>{item?.user_type?.toLowerCase() === 'pgm' ? 'NA' : item?.is_retailer_linked || '-'}</td>}
                          {selectedReport === "user_registration" && <td>{item?.user_type?.toLowerCase() === 'pgm' ? 'NA' : (item?.is_retailer_linked === 'Linked' ? (item?.customer_linked_on ? moment(item?.customer_linked_on).format("DD-MM-YY") : '-') : '-')}</td>}
                          {selectedReport === "qr_code_failure_transaction" && <td>{item?.unique_id}</td>}
                          {selectedReport === "qr_code_failure_transaction" && <td >{item?.message}</td>}
                          {selectedReport === "qr_code_failure_transaction" && <td>{moment(item?.created_at).format("DD-MM-YY")}</td>}
                          {selectedReport === "qr_code_failure_transaction" && <td>{item.is_deleted === true ? "Yes":"No"}</td>}
                          {selectedReport === "qr_code_scan_summary" && <td className="td-center">{item?.total_successful_scans}</td>}
                          {selectedReport === "qr_code_scan_summary" && <td className="td-center">{item?.total_earned_points}</td>}
                          {selectedReport === "qr_code_scan_summary" && <td className="td-center">{item?.total_redeemed_point}</td>}
                          {selectedReport === "qr_code_scan_summary" &&
                            item?.monthly_details && Object.keys(item?.monthly_details)?.map((val) =>
                              <>
                                <td className="td-center">{item?.monthly_details[val].monthly_scans}</td>
                                <td className="td-center">{item?.monthly_details[val].monthly_earned}</td>
                                <td className="td-center">{item?.monthly_details[val].monthly_redeemed}</td>
                              </>
                            )
                          }
                          {selectedReport === "qr_code_scan_summary" && <td>{item.is_deleted === true ? "Yes":"No"}</td>}
                        </tr>
                      )
                    }
                  </table>
                </div>
              </div>
              : report?.length === 0 && selectedReport !== "scan_vs_invoice" ? <NoDataFound /> : ""}
            {report?.length > 0 && selectedReport !== "scan_vs_invoice" && <div className="Pagination_section">
              <Stack spacing={2}>
                <Pagination
                  count={count}
                  className="pagination"
                  page={page}
                  size="medium"
                  defaultPage={1}
                  color="primary"
                  onChange={handlePageChange}
                />
              </Stack>
              <div className="count-report">
                  <b>
                    <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                    </b>
                  </div>
            </div>}
          </div>
          </div>
        )}
      </div>
    </div >
  );
}

export default ReportGeneration;
